import { loadStripe } from '@stripe/stripe-js';
import platformApi, { PLATFORM_ENDPOINTS } from './platformApi';

let platformStripePromise = null;

export const loadPlatformStripe = () => {
  if (!platformStripePromise) {
    platformStripePromise = platformApi.get(PLATFORM_ENDPOINTS.stripeConfig)
      .then((response) => {
        const publishableKey = response?.data?.publishable_key;
        if (!publishableKey || !publishableKey.startsWith('pk_')) {
          throw new Error('Platform Stripe publishable key is unavailable.');
        }
        return loadStripe(publishableKey).then((stripe) => {
          if (!stripe) throw new Error('Platform Stripe could not be initialized.');
          return stripe;
        });
      })
      .catch((error) => {
        platformStripePromise = null;
        throw error;
      });
  }
  return platformStripePromise;
};
